import React, { useState } from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {faBars, faXmark, faAngleDown, faAngleUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {device} from "../../assets/styles/media";

const NavWrapper = styled.div`
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: right;
    max-width: 100vw;
    overflow: hidden;
    
`;

const MenuIcon = styled(FontAwesomeIcon)`
    display: inline-block;
    width: 4vw;
    height: 4vw;
    min-width: 22px;
    min-height: 22px;
    max-width: 35px;
    max-height: 35px;
    cursor: pointer;

    ${device.tablet} {
        padding-right: 30px;
    }
`;

const MenuSection = styled.div`
    opacity: ${(props)=> props.$show? 1 : 0};
    transform: ${( props ) => (props.$show ? 'translateX(0)' : 'translateX(100%)')};
    transition: transform 0.5s ease, opacity 0.5s ease;
    position: fixed;
    left: 0;
    right: 0;
    width: 100vw;
    top: 80px;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    height: 100vh;
    z-index: 1000;
    text-align: left;
    //overflow: hidden;
    box-sizing: border-box;
    & > li {
        padding: 10px;
        box-sizing: border-box;
        border-top: 1px solid #eee;
    }

    ${device.tablet} {
        max-width: 100vw;
        width: 100%;
    }
   
     ${device.mobile} {
         top: 58px;
         padding: 0;
     }
`;
const Li = styled.li`
    display: flex;
    width: auto;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    border-bottom: 1px solid #eee;
    color: ${(props) => props.$active ? "#ed8e0c" : "inherit"};
    transition: all 0.3s ease;
    
    ${device.mobile} {
        height: 60px;
    }
`;
const Dep1 = styled.p`
    font-size: 28px;
    font-weight: 700;
    padding-left: 40px;
    
    ${device.mobile} {
        font-size: 16px;
        padding: 0 20px 0 20px;
    }
`;

const Arrow = styled(FontAwesomeIcon)`
    display: inline-block;
    width: 32px;
    height: 32px;
    padding-right: 10px;
    
    ${device.tablet} {
        width: 27px;
        height: 27px;
        padding-right: 20px;
    }
    
    ${device.mobile} {
        width: 22px;
        height: 22px;
    }
`;

const SubMenuList = styled.ul`
    display: ${({open}) => open ? "block" : "none"};
    list-style: none;
    padding: 20px 0;
    transition: max-height 0.3s ease;
    background-color: #f8f8f8;

    ${device.mobile} {
        padding: 10px 0;
    }
`;

const SubMenuItem = styled.li`
    height: 30px;
    padding: 20px 0 20px 50px;
    font-size: 30px;
    color: #333;
    cursor: pointer;
    ${device.tablet} {
        font-size: 25px;
        height: 28px;
        padding: 18px 0 18px 50px;
    }
    
    ${device.mobile} {
        height: 20px;
        padding: 10px 0 10px 30px;
        font-size: 15px;
        font-weight: 500;
    }
`;

const TabletNav = ({menu}) => {
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(null);
    const [showMenu, setShowMenu] = useState(false);

    const handleTitleClick = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const handleNavigation = (url) => {
        if (url.startsWith("http")) {
            window.open(url, "_blank");
        } else {
            navigate(url);
            setShowMenu(false)
        }
    };


    return (
        <NavWrapper>
            <MenuIcon icon={showMenu ? faXmark : faBars}
                      onClick={() => setShowMenu(prev => !prev)}/>
            <MenuSection $show={showMenu}>
                {menu.map((item, index) => (
                    <React.Fragment key={index}>
                        <Li $active={activeIndex === index}
                            onClick={() => handleTitleClick(index)}>
                            <Dep1>
                                {item.title.name}
                            </Dep1>
                            {activeIndex === index ? <Arrow icon={faAngleUp}/> : <Arrow icon={faAngleDown}/>}
                        </Li>
                        <SubMenuList open={activeIndex === index}>
                            {item.sub.map((sub, subIndex) => (
                                <SubMenuItem
                                    key={subIndex}
                                    onClick={() => handleNavigation(sub.url)}
                                >
                                    {sub.name}
                                </SubMenuItem>
                            ))}
                        </SubMenuList>
                    </React.Fragment>
                ))}
            </MenuSection>
        </NavWrapper>
    );
};

export default TabletNav;
